import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Typography } from "antd";
import moment from "moment";

const { Title, Paragraph } = Typography;

function PostsChart({ posts, viewMode = "monthly", yearFilter = null }) {
  const [chartOptions, setChartOptions] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: true,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
          columnWidth: "55%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        type: "category",
      },
      yaxis: {
        title: {
          text: "Nombre de Postes",
        },
      },
      title: {
        text: "Analyse des Postes",
        align: "left",
      },
      colors: ["#737373", "#52c41a"],
      tooltip: {
        y: {
          formatter: function (val) {
            return val.toFixed(0);
          },
        },
      },
    },
  });

  useEffect(() => {
    if (!posts || posts.length === 0) return;

    const processData = () => {
      try {
        // Filtrer par année si spécifiée
        const filteredPosts = yearFilter
          ? posts.filter(
              (post) => moment(post.creationDate).year() === yearFilter
            )
          : posts;

        if (viewMode === "monthly") {
          // Vue mensuelle
          const months = [
            "Jan",
            "Fév",
            "Mar",
            "Avr",
            "Mai",
            "Jun",
            "Juil",
            "Aoû",
            "Sep",
            "Oct",
            "Nov",
            "Déc",
          ];
          const monthlyData = months.map((month, index) => {
            const monthPosts = filteredPosts.filter(
              (post) => moment(post.creationDate).month() === index
            );

            return {
              month: month,
              count: monthPosts.length,
            };
          });

          return {
            categories: monthlyData.map((d) => d.month),
            series: [
              {
                name: "Nombre de Postes",
                data: monthlyData.map((d) => d.count),
              },
            ],
          };
        } else if (viewMode === "yearly") {
          // Comparaison annuelle
          const years = [
            ...new Set(posts.map((post) => moment(post.creationDate).year())),
          ].sort();

          const yearlyData = years.map((year) => {
            const yearPosts = posts.filter(
              (post) => moment(post.creationDate).year() === year
            );

            return {
              year: year.toString(),
              count: yearPosts.length,
            };
          });

          return {
            categories: yearlyData?.map((d) => d.year),
            series: [
              {
                name: "Nombre de Postes",
                data: yearlyData.map((d) => d.count),
              },
            ],
          };
        }
      } catch (error) {
        console.error("Erreur de traitement des données:", error);
        return { categories: [], series: [] };
      }
    };

    const { categories, series } = processData();

    setChartOptions((prev) => ({
      ...prev,
      series: series ?? [],
      options: {
        ...prev.options,
        chart: {
          ...prev.options.chart,
          type: viewMode === "yearly" ? "bar" : "bar",
        },
        xaxis: {
          ...prev.options.xaxis,
          categories: categories ?? [],
        },
        title: {
          ...prev.options.title,
          text:
            viewMode === "yearly"
              ? `Analyse Annuelle des Postes ${
                  yearFilter ? `(Filtré: ${yearFilter})` : ""
                }`
              : `Analyse Mensuelle des Postes ${
                  yearFilter ? `(Année: ${yearFilter})` : ""
                }`,
        },
      },
    }));
  }, [posts, viewMode, yearFilter]);

  return (
    <div id="chart">
      <ReactApexChart
        options={chartOptions.options}
        series={chartOptions.series}
        type={chartOptions.options.chart.type}
        height={400}
      />
    </div>
  );
}

export default PostsChart;
